export default __webpack_public_path__ + "static/0154-00149edb3cee8155281b13e17116fbb0.png";